import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { AuthenticationService } from '../../auth/service';
import { AppRoutingService } from '../../main/services/app-routing/app-routing.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    /**
     *
     * @param {Router} _router
     * @param {AuthenticationService} _authenticationService
     */
    constructor(
        private _router: Router,
        private approutingService: AppRoutingService,
        private _authenticationService: AuthenticationService,
    ) {}

    // canActivate
    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this._authenticationService.isLoggedIn().pipe(
            map((isLogged) => {
                if (isLogged) {
                    this.approutingService.wantedRoute = state.url;
                    return true;
                } else {
                    this._router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
                    return false;
                }
            }),
            catchError((_err) => {
                this._router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
                return of(false);
            }),
        );
    }
}
